import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { ApisService } from 'src/app/services/apis.service';
import { IRejectReason } from 'src/app/interfaces/order.interface';
import { UtilService } from 'src/app/services/util.service';
import { log } from 'src/app/core/log';
import { codigoDeEtiqueta } from 'src/app/core/language';

@Component({
  selector: 'app-reject-order',
  templateUrl: './reject-order.page.html',
  styleUrls: ['./reject-order.page.scss'],
  standalone: false
})
export class RejectOrderPage implements OnInit {
  reason: string;
  detail: string;
  /** Los motivos de `rejectOrder`, la misma lista que usa el panel. */
  reasons: IRejectReason[] = [];

  constructor(
    private navParam: NavParams,
    private modalController: ModalController,
    private util: UtilService,
    private api: ApisService
  ) {}

  ngOnInit(): void {
    //  `ngOnInit` no puede devolver una promesa: Angular no la espera y el linter lo
    //  rechaza. Se dispara y se maneja el fallo adentro.
    void this.loadReasons();
  }

  async loadReasons(): Promise<void> {
    try {
      this.reasons = await this.api.getRejectReasons('store');
    } catch (error) {
      //  Sin motivos el modal se abre igual: `select()` avisa si no se eligio ninguno.
      //  Dejarlo caer aqui bloquearia al comercio sin poder rechazar.
      this.reasons = [];
      log('no se pudieron cargar los motivos de rechazo', error);
    }
  }

  /**
   * El texto del motivo, que viaja **en el documento** y no en el i18n de esta app.
   *
   * Si el documento no trae etiqueta en este idioma se muestra el `name`: feo, pero
   * legible y sin blancos. Antes un motivo sin clave se mostraba crudo igual, solo que
   * nadie tenia donde arreglarlo sin tocar dos repos.
   */
  label(motivo: IRejectReason): string {
    return motivo.labels?.[codigoDeEtiqueta()] ?? motivo.name;
  }

  select() {
    if (this.reason === undefined || this.reason === '') {
      void this.util.errorToast('Elige el motivo del rechazo');
      return false;
    } else {
      void this.modalController.dismiss({ reason: this.reason, detail: this.detail }, 'rejected');
    }
  }
  close() {
    void this.modalController.dismiss([], 'close');
  }
}
